
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_7py6d_185",
  "grid": "awsui_grid_vj6p7_7py6d_220",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_7py6d_226",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_7py6d_230",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_7py6d_238",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_7py6d_241",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_7py6d_241",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_7py6d_244",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_7py6d_247",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_7py6d_253",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_7py6d_259",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_7py6d_275",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_7py6d_308",
  "root": "awsui_root_vj6p7_7py6d_358",
  "tile-container": "awsui_tile-container_vj6p7_7py6d_396",
  "refresh": "awsui_refresh_vj6p7_7py6d_421",
  "has-metadata": "awsui_has-metadata_vj6p7_7py6d_425",
  "selected": "awsui_selected_vj6p7_7py6d_431",
  "disabled": "awsui_disabled_vj6p7_7py6d_436",
  "readonly": "awsui_readonly_vj6p7_7py6d_441",
  "columns": "awsui_columns_vj6p7_7py6d_447",
  "column-1": "awsui_column-1_vj6p7_7py6d_454",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_7py6d_461",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_7py6d_465",
  "column-2": "awsui_column-2_vj6p7_7py6d_469",
  "column-3": "awsui_column-3_vj6p7_7py6d_484",
  "column-4": "awsui_column-4_vj6p7_7py6d_499",
  "control": "awsui_control_vj6p7_7py6d_515",
  "no-image": "awsui_no-image_vj6p7_7py6d_519",
  "image": "awsui_image_vj6p7_7py6d_523"
};
  